// extracted by mini-css-extract-plugin
module.exports = {"container":"container___2BFTk","button":"button___1FNGr","wrapper":"wrapper___2lkX9","lgUp":"lgUp___3hMif","searchCorrectionQuery":"searchCorrectionQuery___3P2KL"};